<template>
  <div>
    <div class="fixed width-100 z-99">
      <van-tabs v-model="tabIndex">
        <van-tab title="发起提交"></van-tab>
        <van-tab title="查看数据"></van-tab>
      </van-tabs>
    </div>
    <!--  站位盒子  -->
    <div class="h-98"></div>
    <!--  列表  -->
    <list v-show="tabIndex === 1" ref="list" @change="listChange" @to_refund_a_ticket="to_refund_a_ticket"></list>
    <!--  表单  -->
    <addOrUpdate v-show="tabIndex === 0" ref="addOrUpdate"></addOrUpdate>


  </div>
</template>

<script>
import addOrUpdate from './form.vue'
import list from './list.vue'
import {mapMutations} from "vuex";

export default {
  name: 'reimbursement',
  components: {addOrUpdate, list},
  data() {
    return {
      tabIndex: 0,
      routeQuery: {},

    }
  },
  created() {
    this.routeQuery = this.$route.query
  },

  methods: {
    ...mapMutations({
      SET_PROCESS_INSTANCE_ID: 'process/SET_PROCESS_INSTANCE_ID',
      SET_TASK_ID: 'process/SET_TASK_ID',
    }),
    // 退票
    to_refund_a_ticket(data) {
      const {processInstanceId} = data
      const query = {
        ...this.$route.query, processInstanceId
      }
      // 退票流程的templateId
      const templateId = '8E4534D22F1846CF8CD470EC8CE86C57'
      window.location.href = `${window.location.origin}/refundTicket?isRelevanceFlow=1&destGroupId=28&destProcessInstanceId=${processInstanceId}&templateId=${templateId}`
    },
    listChange(data) {
      const {processInstanceId, taskId} = data
      const query = {
        ...this.$route.query, processInstanceId, taskId
      }
      window.location.href = `${window.location.origin}${window.location.pathname}?processInstanceId=${processInstanceId}&taskId=${taskId}&groupId=${query.groupId}&templateId=${data.businessData.templateId}`

    }
  }
}
</script>


<style scoped lang="less">
.jisu {
  font-size: 28px;
}
</style>
